import CrudService from "services/cruds-service";

export const toFiniteNumber = (value) => {
  if (value == null || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export function normalizeTransfer(raw) {
  if (!raw) return null;
  const type = raw.type ?? raw.transfer_type ?? "unknown";
  const status = raw.status ?? "unknown";
  return {
    id: String(raw.id ?? raw.public_id ?? ""),
    sourceTransferId: String(raw.sourceTransferId ?? raw.source_transfer_id ?? ""),
    deviceId: raw.deviceId ?? raw.device_id ?? raw.local_device_id ?? null,
    type,
    direction: raw.direction ?? (type === "pick" || type === "fill" ? "in" : type === "drop" ? "out" : null),
    status,
    startedAt: raw.startedAt ?? raw.started_at ?? null,
    stoppedAt: raw.stoppedAt ?? raw.stopped_at ?? null,
    durationSeconds: toFiniteNumber(raw.durationSeconds ?? raw.duration_seconds),
    businessDate: raw.businessDate ?? raw.business_date ?? null,
    businessTimezone: raw.businessTimezone ?? raw.business_timezone ?? null,
    startGallons: toFiniteNumber(raw.startGallons ?? raw.start_gallons),
    stopGallons: toFiniteNumber(raw.stopGallons ?? raw.stop_gallons),
    reportedGallons: toFiniteNumber(raw.reportedGallons ?? raw.reported_gallons),
    calculatedGallons: toFiniteNumber(raw.calculatedGallons ?? raw.calculated_gallons),
    gallonsTransferred: toFiniteNumber(raw.gallonsTransferred ?? raw.gallons_transferred ?? raw.final_gallons),
    varianceGallons: toFiniteNumber(raw.varianceGallons ?? raw.variance_gallons),
    validationStatus: raw.validationStatus ?? raw.validation_status ?? "pending",
    validationMessages: Array.isArray(raw.validationMessages)
      ? raw.validationMessages
      : Array.isArray(raw.validation_messages)
        ? raw.validation_messages
        : [],
    operator: raw.operator ?? null,
    assetId: raw.assetId ?? raw.asset_id ?? null,
    routeId: raw.routeId ?? raw.route_id ?? null,
    jobId: raw.jobId ?? raw.job_id ?? null,
    startLocation: raw.startLocation ?? raw.start_location ?? null,
    stopLocation: raw.stopLocation ?? raw.stop_location ?? null,
    eventCount: toFiniteNumber(raw.eventCount ?? raw.event_count) ?? 0,
    restatementCount: toFiniteNumber(raw.restatementCount ?? raw.restatement_count) ?? 0,
    corrected: Boolean(raw.corrected),
    voided: Boolean(raw.voided) || status === "voided",
    voidReason: raw.voidReason ?? raw.void_reason ?? null,
    version: toFiniteNumber(raw.version) ?? 0,
    updatedAt: raw.updatedAt ?? raw.updated_at ?? null,
  };
}

export const isCountedTransfer = (transfer) =>
  transfer?.status === "stopped" &&
  ["valid", "warning"].includes(transfer.validationStatus) &&
  transfer.gallonsTransferred != null &&
  !transfer.voided;

export async function getTransferPage({ deviceId, from, to, cursor, limit = 50, signal }) {
  const response = await CrudService.getTabletTransfers({ deviceId, from, to, cursor, limit, signal });
  return {
    transfers: (response?.data ?? []).map(normalizeTransfer).filter(Boolean),
    nextCursor: response?.nextCursor ?? null,
  };
}

export async function getTransferSummary({ deviceId, from, to, signal }) {
  const response = await CrudService.getTabletTransferSummary({ deviceId, from, to, signal });
  return Array.isArray(response?.data) ? response.data[0] ?? null : response?.data ?? null;
}

export async function getTransferEvents(publicId, signal) {
  const response = await CrudService.getTabletTransferEvents(publicId, signal);
  return response?.data ?? [];
}

export async function getTransferCorrections(publicId, signal) {
  const response = await CrudService.getTabletTransferCorrections(publicId, signal);
  return response?.data ?? [];
}
